import React from 'react';
import { useServiceWorker, useLocale } from 'hooks';
import { IconButton, Snackbar } from '@material-ui/core';

import { Button } from 'ui';
import { CloseIcon } from 'ui/icons/closeIcon/CloseIcon';

import { useStyles } from './UpdateSnackbar.styles';

export const UpdateSnackBar = () => {
  const { updateApp, updateAvailable, closeNotification } = useServiceWorker();
  const { formatMessage } = useLocale();
  const classes = useStyles();
  return (
    <Snackbar
      open={updateAvailable}
      message={formatMessage({ id: 'common.newVersionAvailable' })}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      action={
        <>
          <Button className={classes.button} size="small" color="secondary" variant="text" onClick={updateApp}>
            {formatMessage({ id: 'common.update' })}
          </Button>
          <IconButton
            size="small"
            className={classes.closeIcon}
            aria-label="close"
            title="close"
            color="inherit"
            onClick={closeNotification}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </>
      }
    />
  );
};
